export const SHOW_CONFIRM = 'SHOW_CONFIRM';
export const HIDE_CONFIRM = 'HIDE_CONFIRM';

export const initialState = {
    show: false,
    title: '',
    text: '',
    rejectLabel:'Cancel',
    confirmLabel: 'OK',
    width: 'sm',
    showReject: true
}

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_CONFIRM:
            return {
                show: true,
                title: action.payload.title,
                text: action.payload.text,
                rejectLabel: action.payload.rejectLabel,
                confirmLabel: action.payload.confirmLabel,
                width: action.payload.width,
                showReject: action.payload.showReject
            };
        case HIDE_CONFIRM:
            return initialState;
        default:
            return initialState;
    }
};